import React, { useState, useContext, useEffect, useRef } from "react";

import { useScreenTransition } from "../../Hooks/useScreenTransition";

import { AuthContext } from "../../Context/AuthContext";
import { TransitionContext } from "../../Context/TransitionContext";
import { NotificationContext } from "../../Context/NotificationContext";

import { languages } from "../../Data/languages";
import { ReactComponent as DOWN } from "../../assets/icons/filter-down.svg";
import { ReactComponent as UP } from "../../assets/icons/filter-up.svg";
import { ReactComponent as SORTBLACK } from "../../assets/icons/sort-black.svg";
import { ReactComponent as MORE } from "../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../assets/icons/More-selected.svg";
import { ReactComponent as PAYMENT } from "../../assets/icons/dollar.svg";
import { ReactComponent as CHECK } from "../../assets/icons/check.svg";
import { ReactComponent as SEND } from "../../assets/icons/Send.svg";
import { ReactComponent as STATUS } from "../../assets/icons/Status.svg";
import { ReactComponent as DATE } from "../../assets/icons/Date.svg";
import { ReactComponent as LANGUAGES } from "../../assets/icons/Languages.svg";
import { ReactComponent as SERVICES } from "../../assets/icons/Services.svg";
import { ReactComponent as EXPEDITED } from "../../assets/icons/order-expedited.svg";
import { ReactComponent as EXPEDITEDPLUS } from "../../assets/icons/expedited-plus.svg";
import { ReactComponent as HARDCOPY } from "../../assets/icons/order-hard-copy.svg";
import { ReactComponent as NOTRY } from "../../assets/icons/order-notry.svg";
import { ReactComponent as TRANSLATOR } from "../../assets/icons/Client.svg";
import { ReactComponent as CLIENT } from "../../assets/icons/placed-by.svg";
import { ReactComponent as CANCELORDER } from "../../assets/icons/cancel-order.svg";
import { ReactComponent as INFO } from "../../assets/icons/Info.svg";
import { ReactComponent as SEARCHICON } from "../../assets/icons/search.svg";
import { ReactComponent as MESSAGE } from "../../assets/icons/Message-icons.svg";
import { ReactComponent as SORT_ASC } from "../../assets/icons/sort-asc.svg";
import { ReactComponent as SORT_DSC } from "../../assets/icons/sort-dsc.svg";
import AccountNavBar from "../../NewComponents/AccountNavBar";
import NoData from "../../NewComponents/NoData";
import { DataContext } from "../../Context/DataContext";
import DateFilter from "../Account/OrdersComponents/DateFilter";
import LanguageFilter from "../Account/OrdersComponents/LanguageFilter";
import SearchFilter from "../Account/OrdersComponents/SearchFilter";
import PopUpModal from "../../NewComponents/PopUpModal";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils";
import SendPaymentLinkPopUp from "../../NewComponents/SendPaymentLinkPopUp";
import Clientsfilter from "../Account/OrdersComponents/Clientsfilter";
import { ORDERSTATUS } from "../../Data/statuses";
import {
  formatTotal,
  getDiscount,
  getDue,
  getExpedited,
  getHardCopyPrice,
  getOrderPageCountTotal,
  getShortOrderNo,
  getTotal,
  signaturePrice,
} from "../../Data/Functions";
import TranslatorDropdown from "../Account/OrdersComponents/TranslatorDropdown";
import { AccountType } from "../../utility/enums";
import { checkFetchAlgoliaData, firestore } from "../../firebase.config";
import ReopenOrderPopup from "../../NewComponents/ReopenOrderPopup";
import MessageDot from "../../NewComponents/MessageDot";
import OpenInvoiceModal from "../../NewComponents/OpenInvoiceModal";
import { Configure, Pagination, SearchBox, useHits, useInstantSearch, useSearchBox, useSortBy } from "react-instantsearch-hooks-web";
import { useSpring, animated } from "react-spring";
import { Link } from "react-router-dom";
import QueryFilters from "../Account/OrdersComponents/QueryFilters";


const OrdersBackendComponent = ({ windowSize }) => {
  const { transitionTo } = useScreenTransition();

  const { setColor } = useContext(TransitionContext);
  const { showNotification } = useContext(NotificationContext);
  const { userData, teamData } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);

  const moreOptionsRef = useRef(null);
  const [moreOptions, setMoreOptions] = useState("");
  const [showDetailModal, setShowDetailModal] = useState("");

  const [statusFilter, setStatusFilter] = useState("");
  const [servicesFilter, setServicesFilter] = useState([]);

  const [showFilter, setShowFilter] = useState("");

  const [filterStartTimestamp, setFilterStartTimestamp] = useState(null);
  const [filterEndTimestamp, setFilterEndTimestamp] = useState(null);
  const [selectedLanguageFilter, setSelectedLanguageFilter] = useState({
    languageFrom: "",
    languageTo: "",
  });
  const [datePeriod, setDatePeriod] = useState("custom");

  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [selectedTranslators, setSelectedTranslators] = useState([]);

  const [selectedCancelModal, setSelectedCancelModal] = useState("");
  const [selectedDeleteModal, setSelectedDeleteModal] = useState("");
  const [cancelBtnText, setCancelBtnText] = useState("Cancel Order");
  const [deleteBtnText, setDeleteBtnText] = useState("Delete Order");
  const [selectedSendPayment, setSelectedSendPayment] = useState("");
  const [changeTranslator, setChangetranslator] = useState(false);

  const [openInvoiceModal, setOpenInvoiceModal] = useState();
  
  const [reOpenOrderPopup, setReopenOrderPopup] = useState("");

  let nextPointer = useRef();
  if (!nextPointer.current) nextPointer.current = null;

  useEffect(() => {
    setColor(true);
  }, [setColor]);

    const [localOrders, setLocalOrders] = useState([]);

  useEffect(()=> {
      if(!checkFetchAlgoliaData()){
        if(signedIn && userData.id){
          firestore.collection("orders").orderBy("timestamp", "desc").get()
          .then(qSnap => {
            if(qSnap.empty){
              return;
            }
  
            setLocalOrders(qSnap.docs.map(doc => ({...doc.data(), objectID: doc.id})));
          })
        }
      }
  
    }, 
    [userData])

  useEffect(() => {
    if(!signedIn || (userData && userData.role === "client")){
      return transitionTo("/");
    }
  }, [signedIn, userData]);

  useEffect(() => {
    if (signedIn && userData) {
    
      firestore
        .collection("users").orderBy("name", "asc")
        .get()
        .then((qSnap) => {
          if (!qSnap.empty) {
            setClients(
              qSnap.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
        });
    }
  }, [signedIn, userData]);

   useEffect(() => {
     const handleClickOutside = (event) => {
       if (!event.target.closest('.hardCopyAddressIconWrap')) {
         setMoreOptions("");
       }
     };
     document.addEventListener("mousedown", handleClickOutside);
     return () => {
       document.removeEventListener("mousedown", handleClickOutside);
     };
   }, []);

  const formatDate = (timestamp, showTime = false) => {
    const date = new Date(timestamp);

    const splitted = date.toDateString().split(" ");

    const time = showTime ? " @ " + date.toTimeString().substr(0, 5) : "";

    return splitted[1] + " " + splitted[2] + ", " + splitted[3] + time;
  };

  const getLanguage = (language) => {
    if (languages.find((lang) => lang.value === language)) {
      return languages.find((lang) => lang.value === language).label;
    } else {
      return "";
    }
  };


  const formatDiscount = (value) => {
    return "-$" + value.toFixed(2);
  };

  const formatFilterDate = (date) => {
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  };

  const getSelectedDateText = () => {
    if (filterStartTimestamp) {
      if (filterEndTimestamp) {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date(filterEndTimestamp))
        );
      } else {
        return (
          formatFilterDate(new Date(filterStartTimestamp)) +
          " - " +
          formatFilterDate(new Date())
        );
      }
    } else {
      return "Date";
    }
  };

  const getLanguageLabel = (value) => {
    const language = languages.find((l) => l.value === value);

    if (language) {
      return language.label;
    } else {
      return "";
    }
  };

  const getSelectedLanguage = () => {
    if (
      selectedLanguageFilter.languageFrom !== "" &&
      selectedLanguageFilter.languageTo !== ""
    ) {
      return (
        getLanguageLabel(selectedLanguageFilter.languageFrom) +
        " to " +
        getLanguageLabel(selectedLanguageFilter.languageTo)
      );
    } else {
      return "Languages";
    }
  };

  const checkAnyFilterSelected = () => {
    if (filterStartTimestamp) {
      return true;
    }
    if (filterEndTimestamp) {
      return true;
    }
    if (
      selectedLanguageFilter.languageFrom &&
      selectedLanguageFilter.languageTo
    ) {
      return true;
    }
    if (selectedClients.length > 0) {
      return true;
    }
    if (servicesFilter.length > 0) {
      return true;
    }
    if (statusFilter !== "") {
      return true;
    }
    if(selectedTranslators.length > 0){
      return true;
    }
    return false;
  };

  const handleCancelOrder = (isPaid) => {
    setMoreOptions("");
    setCancelBtnText("Cancelling...");

    firestore
      .collection("orders")
      .doc(selectedCancelModal.id)
      .update({
        status: isPaid ? "on-hold" :
          selectedCancelModal.status === "new" || selectedCancelModal.status === "draft"
            ? "cancelled"
            :  "on-hold",
          cancellationHold: isPaid ? true:
          selectedCancelModal.status === "new" || selectedCancelModal.status === "draft"
            ? false
            :  true
      })
      .then(() => {
        setTimeout(() => {
          refresh();
          setCancelBtnText("Cancel Order");
          setSelectedCancelModal("");
          setMoreOptions("");
        }, 6000)
      }).catch((e) =>
        {
          setCancelBtnText("Cancel Order");
          showNotification(
            "Error",
            "Error occured cancelling the order please try again",
            "error"
          )
        }
      )
  };


  const handleUpdateTranslator = (order, newTranslator) => {
    const { id, status } = order;
    if (id && newTranslator) {
      const due = getDue(true,order);
      const now = new Date();
      
      const updateRecord = {
        translator: newTranslator,
        status: 'in-progress',
        due: due,
        overdue: false,
        assigned: now.getTime()
      };
      if (status === "new" || status === "Assigned" || status === "assigned") {
        updateRecord.status = "in-progress";
      }
      
      firestore
        .collection("orders")
        .doc(id)
        .update(updateRecord)
        .then(() => {
          setRefreshing(true)
          setTimeout(() => {
            refresh();
            setRefreshing(false);
          }, 6000) 
          setChangetranslator(!changeTranslator);
        });
    }
  };
 
  const downloadPackage = (order) => {
    setMoreOptions("");
    generateDocument(order);
  };

  const downloadFolderAsZip = async (order, invoiceFile) => {
    const jszip = new JSZip();
    const sourceFiles = order.files.filter(
      (f) =>
        f.type === "source" || f.type === "reference" || f.type === "client"
    );
    const translatedFiles = order.files.filter(
      (f) =>
        (f.type === "translation" ||
          (f.type === "revision" &&
            (order.status === "user-review" ||
              order.status === "completed"))) &&
        (!order.certified || f.format === "application/pdf")
    );
    const downloadedFiles = await Promise.all(
      sourceFiles
        .concat(translatedFiles)
        .map((file) => fetch(file.url).then((res) => res.blob()))
    );
    downloadedFiles.forEach((file, i) => jszip.file(order.files[i].name, file));
    jszip.file(`invoice_${order.orderNumber}.docx`, invoiceFile);
    const content = await jszip.generateAsync({ type: "blob" });
    saveAs(content, `${order.orderNumber}`);
  };

  function loadFile(url, callback) {
    PizZipUtils.getBinaryContent(url, callback);
  }

  const generateDocument = (orderInfo) => {
    loadFile(
      "https://firebasestorage.googleapis.com/v0/b/project-everbary.appspot.com/o/invoiceTemplate.docx?alt=media&token=5b304c5f-5863-4e89-ac4c-3da7464e343e",
      function (error, content) {
        if (error) {
          throw error;
        }
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip);
        doc.render({
          orderNumber: orderInfo.orderNumber,
          orderDate: formatDate(orderInfo.timestamp, true),
          orderReference: orderInfo.reference || "",
          name: teamData ? teamData.name : orderInfo.name,
          email: orderInfo.email,
          translationType: orderInfo.certified
            ? "Certified Translation"
            : "Standard Translation",
          pages: orderInfo.certified
            ? orderInfo.pagesCount !== ""
              ? orderInfo.pagesCount +
              " pages (" +
              parseInt(orderInfo.pagesCount, 10) * 250 +
              " words max)"
              : "0 pages (0 words max)"
            : orderInfo.wordCount !== ""
              ? orderInfo.wordCount + " words"
              : "0 words",
          unitPrice: "24.95",
          pageTotal:
            orderInfo.pagesCount !== ""
              ? "$" + getOrderPageCountTotal(orderInfo).toFixed(2)
              : "$0.00",
          notaryCount: orderInfo.notarization ? "1" : "",
          notaryUnit: orderInfo.notarization ? "$34.90" : "",
          notaryPrice: orderInfo.notarization ? "$34.90" : 0,
          expedited: orderInfo.expeditedPlus
            ? "Expedited Plus Turnaround"
            : "Expedited Turnaround",
          expeditedPrice:
            orderInfo && orderInfo.expedited
              ? formatTotal(getExpedited(orderInfo))
              : "",
          hardCopy:
            orderInfo.hardCopy && orderInfo.hardCopyExtra &&
              orderInfo.hardCopyExtra.country !== "" &&
              orderInfo.hardCopyExtra.method !== ""
              ? `USPS ${orderInfo.hardCopyExtra.method.charAt(0).toUpperCase() +
              orderInfo.hardCopyExtra.method.slice(1)
              } Mail ${![
                "United States",
                "Puerto Rico",
                "U.S. Virgin Islands",
              ].includes(orderInfo.hardCopyExtra.country)
                ? "International"
                : "Hard Copy"
              }`
              : "Hard Copy",
          hardCopyPrice: getHardCopyPrice(
            orderInfo.hardCopy && orderInfo.hardCopyExtra && orderInfo.hardCopyExtra.country,
            orderInfo.hardCopy && orderInfo.hardCopyExtra && orderInfo.hardCopyExtra.method,
            false,
            orderInfo
          ),
          signature: signaturePrice(
            orderInfo.hardCopy && orderInfo.hardCopyExtra && orderInfo.hardCopyExtra.requireSignature,
            orderInfo
          ),
          signaturePrice: signaturePrice(
            orderInfo.hardCopy && orderInfo.hardCopyExtra && orderInfo.hardCopyExtra.requireSignature,
            orderInfo
          ),
          subTotal: orderInfo ? formatTotal(getTotal(orderInfo)) : 0,
          discountPercent:
            orderInfo.discount && orderInfo.discount > 0
              ? `(${orderInfo.discount}%)`
              : "",
          discount:
            orderInfo && orderInfo.discount && orderInfo.discount > 0
              ? formatDiscount(getDiscount(orderInfo))
              : 0,
          total: orderInfo
            ? formatTotal(getTotal(orderInfo) - getDiscount(orderInfo))
            : 0,
        });

        const out = doc.getZip().generate({
          type: "blob",
          mimeType:
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        });
        downloadFolderAsZip(orderInfo, out);
      }
    );
  };


  const hasValidPaypalOrderID = (paypalOrderID) => {
    return paypalOrderID && paypalOrderID !== "pay-later";
  };

  const checkOrderStatus = (order) => {
    const status = order.cancellationHold && order.status === "on-hold" ? ORDERSTATUS["cancel-hold"][0] : ORDERSTATUS[order.status]
      ? ORDERSTATUS[order.status][0]
      : order.status;
    return status === "Completed" ? "Approved" : status;
  };

  const handleReopanOrederPopup = () => {
    setReopenOrderPopup('');
  }

  const ReopenOrder = (order) => {

    firestore
      .collection("orders")
      .doc(order.id)
      .update({
        status: "new",

      })
      .then(() => {
        showNotification(
          "Success",
          "Order has been succesfully reopened.",
          "success"
        );
      })
      .catch((error) => {
        showNotification(
          "Error",
          "An error ocurred reopening the order. Please, try again. If it persists, contact technical support.",
          "error"
        );
      });

    handleReopanOrederPopup(''); 

  };

  const handleOpenInvoice = (order) => {
    setMoreOptions("");
    setOpenInvoiceModal(order);
  }

  const {hits} = useHits();
  const {status, refresh} = useInstantSearch();
  const {query} = useSearchBox();
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  
  
  const items = [
      {
      Label: "Default",
      value: "orders"
      },
      {
      Label: "Date asc",
      value: "order_time_asc"
      },
      {
      Label: "Date dsc",
      value: "order_time_dsc"
      },
      {
      Label: "Name asc",
      value: "order_requestBy_asc"
      },
      {
      Label: "Name dsc",
      value: "order_requestBy_dsc"
      },
      {
      Label: "Client asc",
      value: "order_client_asc"
      },
      {
      Label: "Client dsc",
      value: "order_client_dsc"
      },
      {
      Label: "Status asc",
      value: "order_status_asc"
      },
      {
      Label: "Status dsc",
      value: "order_status_dsc"
      },
      {
      Label: "Translator asc",
      value: "order_translator_asc"
      },
      {
      Label: "Translator dsc",
      value: "order_translator_dsc"
      },
  ]
  const { currentRefinement, refine } = useSortBy({items: items, defaultRefinement: "order_time_dsc"});
  
  useEffect(() => {
      if(status === "loading" || status === "stalled"){
      setLoading(true);
      }else{
      setLoading(false);
      }
  }, [status])
  
  useEffect(() => {
      if(currentRefinement === "orders"){
      refine("order_time_dsc");
      }
  }, [currentRefinement])
  
  
    const [filters, setFilters] = useState("");

    useEffect(() => {
        let tempFilters = "";
        
        if(filterStartTimestamp && filterEndTimestamp){
            tempFilters += `${tempFilters === "" ? "" : " AND"} timestamp >= ${filterStartTimestamp} AND timestamp <= ${filterEndTimestamp}`
        }
        if(selectedLanguageFilter && selectedLanguageFilter.languageFrom && selectedLanguageFilter.languageTo){
            tempFilters += `${tempFilters === "" ? "" : " AND"} languageFrom:${selectedLanguageFilter.languageFrom} AND languageTo:${selectedLanguageFilter.languageTo}`;
        }
        if(selectedClients.length > 0){
            selectedClients.forEach((email, i) => {tempFilters +=`${tempFilters === "" ? "" : (i === 0 ? " AND" : " OR")} email:${email}`});
        }
        if(selectedTranslators){
            selectedTranslators.forEach((client, i) => {
                tempFilters +=`${tempFilters === "" ? "" : (i === 0 ? " AND" : " OR")} translator.name:"${client}"`
            });
        }
        if (servicesFilter.includes("notry")){
            tempFilters+= `${tempFilters === "" ? "" : " AND"} notarization:true`;
        }
        if (servicesFilter.includes("expedited")){
            tempFilters += `${tempFilters === "" ? "" : " AND"} expedited:true`;
        }
        if (servicesFilter.includes("expedited+")){
            tempFilters += `${tempFilters === "" ? "" : " AND"} expeditedPlus:true`;
        }
        if (servicesFilter.includes("hardCopy")){
            tempFilters+= `${tempFilters === "" ? "" : " AND"} hardCopy:true`;
        }
        if(statusFilter){
            tempFilters+= `${tempFilters === "" ? "" : " AND"} status:${statusFilter}`;
        }

        setFilters(tempFilters);
    }
    , [filterStartTimestamp, filterEndTimestamp, userData, selectedLanguageFilter,selectedTranslators, servicesFilter, statusFilter, selectedClients])

    const handleShowMore = (value) => {
        setShowFilter("");
        setMoreOptions(value);
    }
    // console.log("filters>>>>>>>>>>>>",filters)

  const TableDataComponent = ({hits }) => {
  
      if(hits.length === 0){
        return <tbody></tbody>;
      }
  
      return (
        <tbody>
        {hits.map(hit =>
        {
          const order = {...hit, id: hit.objectID}
          return (
             <tr key={order.id} onClick={(e) => transitionTo(`/office/translations/${order.id}`, e)}>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                      {order.orderNumber && order.orderNumber.toString().length > 12 &&
                          showDetailModal === order.orderNumber && (
                          <div className="accountdetailHoverBox">
                              <p
                              className="quotewidth "
                              >
                              {order.orderNumber}
                              </p>
                          </div>
                          )}
                      <p className="quotewidth accountDetailsLink" 
                          onMouseOver={() =>
                          setShowDetailModal(
                              order.orderNumber
                          )
                          }
                          onMouseLeave={() => setShowDetailModal("")}>
                          {getShortOrderNo(order.orderNumber, "order")}
                      </p>
                    </Link>
                </td>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <p className="quotewidth">
                    {formatDate(order.timestamp)}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {order.name &&
                    order.name.length > 14 &&
                    showDetailModal === order.id + order.name && (
                        <div className="accountdetailHoverBox">
                        <p
                            className="quotewidth captialLetters"
                        >
                            {order.name}
                        </p>
                        </div>
                    )}
                    <p
                    className="quotewidth captialLetters overflowText"
                    style={{ cursor: "pointer" }}
                    onMouseOver={() =>
                        setShowDetailModal(order.id + order.name)
                    }
                    onMouseLeave={() => setShowDetailModal("")}
                    >

                    {(userData?.role === "Support" &&  "Support Plus") ? "***@***" : order.name || "-"}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {order.email &&
                    order.email.length > 14 &&
                    showDetailModal === order.id + order.email && (
                        <div className="accountdetailHoverBox ">
                        <p
                            className="quotewidth lowercaseLetter"

                        >
                            {(userData?.role === "Support" &&  "Support Plus") ? null : order.email}
                        </p>
                        </div>
                    )}
                    <p
                    className="quotewidth lowercaseLetter overflowText"
                    style={{ cursor: "pointer" }}
                    onMouseOver={() =>
                        setShowDetailModal(order.id + order.email)
                    }
                    onMouseLeave={() => setShowDetailModal("")}
                    >
                    {(userData?.role === "Support" && "Support Plus") ? "***@***.com" : order.email || "-"}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {showDetailModal ===
                    order.id + order.languageFrom && (
                        <div className="accountdetailHoverBox ">
                        <p
                            className="quotewidth captialLetters"
                        >
                            {getLanguage(order.languageFrom) +
                            " / " +
                            getLanguage(order.languageTo)}
                        </p>
                        </div>
                    )}
                    <p
                    className="quotewidth"
                    style={{
                        textTransform: "uppercase",
                        cursor: "pointer",
                    }}
                    onMouseOver={() =>
                        setShowDetailModal(
                        order.id + order.languageFrom
                        )
                    }
                    onMouseLeave={() => setShowDetailModal("")}
                    >
                    {getLanguage(order.languageFrom).substr(0, 2) +
                        "/" +
                        getLanguage(order.languageTo).substr(0, 2)}
                    </p>
                  </Link>
                </td>

                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    {showDetailModal === order.id + "N" && (
                    <div className="accountdetailHoverBox ">
                        <p
                        className="quotewidth captialLetters"
                        >
                        Notarization
                        </p>
                    </div>
                    )}
                    {showDetailModal === order.id + "E" && (
                    <div className="accountdetailHoverBox ">
                        <p
                        className="quotewidth captialLetters"
                        >
                        {order.expeditedPlus
                            ? "Expedited+ Turnaround"
                            : "Expedited Turnaround"}
                        </p>
                    </div>
                    )}
                    {showDetailModal === order.id + "H" && (
                    <div className="accountdetailHoverBox">
                        <p
                        className="quotewidth captialLetters"
                        >
                        Mail Hard Copy
                        </p>
                    </div>
                    )}
                    <p className="quotewidth captialLetters services">
                      <div className="opacity-0" > .</div>
                    {order.notarization && (
                        <NOTRY
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "N")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {order.expedited && (
                        <EXPEDITED
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "E")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}
                    {order.expeditedPlus && (
                        <EXPEDITEDPLUS
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "E")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    )}

                    {order.hardCopy ? (
                        <HARDCOPY
                        style={{ cursor: "pointer" }}
                        onMouseOver={() =>
                            setShowDetailModal(order.id + "H")
                        }
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    ) : (
                        ""
                    )}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <div className="flex">
                      <MessageDot chatId={order.generalChatId}/>
                      <MessageDot chatId={order.everbaryChatId} type="everbary"/>
                    </div>
                    {/* <FileCommentIndicator orderId={order.id} /> */}
                  </Link>
                </td>
                <td onClick={(e) => e.stopPropagation()}>
                    {order.status === "completed" ? (
                    <span style={{ paddingLeft: "18px" }}>
                        {order?.translator?.name}
                    </span>
                    ) : (
                    <TranslatorDropdown
                        order={order}
                        handleUpdateTranslator={
                        handleUpdateTranslator
                        }
                        clients={clients.filter(
                        (el) =>
                            ['Translator', 'Support','support', 'Support Plus','supportPlus'].includes(el.role) &&
                        
                            el.name
                        )}
                        type="orders"
                    />
                    )}
                </td>
                <td
                >
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <p
                    className="quotewidth accountDetailsStatus"
                    style={{
                        backgroundColor: order.cancellationHold && order.status === "on-hold" ? ORDERSTATUS["cancel-hold"][1] : ORDERSTATUS[order.status]
                        ? ORDERSTATUS[order.status][1]
                        : "",
                    }}
                    >
                    {checkOrderStatus(order)}
                    </p>
                  </Link>
                </td>
                <td>
                  <Link to={`/office/translations/${order.id}`} onClick={(e) => e.stopPropagation()}>
                    <p className="quotewidth">
                    {order.pagesCount === undefined ||
                        order.wordCount === undefined
                        ? "-"
                        : (userData?.role === "Support" && "Support Plus") ? "$***" : formatTotal(
                        getTotal(order) - getDiscount(order)
                        )}
                    </p>
                  </Link>
                </td>
                <td>
                    <p className="quotewidth replied">
                    {hasValidPaypalOrderID(order.paypalOrderID) ? (
                        <CHECK />
                    ) : (
                        <>
                        {showDetailModal ===
                            order.id + "paymentLink" && (
                            <div className="accountdetailHoverBox left-[-40px]">
                                <p
                                className="quotewidth"
                                style={{
                                    textTransform: "capitalize",
                                }}
                                >
                                Share Payment Link
                                </p>
                            </div>
                            )}
                        <button
                            className="sendPaymentLink"
                            onClick={(e) => {
                            e.stopPropagation();
                            setSelectedSendPayment(order);
                            }}
                            onMouseOver={() =>
                            setShowDetailModal(
                                order.id + "paymentLink"
                            )
                            }
                            onMouseLeave={() =>
                            setShowDetailModal("")
                            }
                        >
                            <SEND />
                        </button>
                        </>
                    )}
                    </p>
                </td>
                <td  onClick={(e) => e.stopPropagation()}>
                <div
                    className="hardCopyAddressIconWrap "
                    ref={moreOptionsRef}
                    onClick={(e) => {
                    e.stopPropagation(); // Prevents event bubbling
                    }}
                    tabIndex={0} // Enables blur event for accessibility
                    onBlur={() => setMoreOptions("")}
                >
                    {moreOptions === order.id ? (
                    <MORESELECTED
                        className="hardCopyAddressIcon"
                    onClick={() => handleShowMore("")}
                    />
                    ) : (
                    <MORE
                        className="hardCopyAddressIcon"
                        onClick={(e) => {
                        e.stopPropagation(); // Prevents event bubbling
                        handleShowMore(order.id);
                        }}
                    />
                    )}

                    {moreOptions === order.id &&
                    (order.status === "in-progress" ||
                        order.status === "assigned") && (
                        <div className="hardCopyAddressEditWrap">
                        <div
                            className="hardCopyAddressEdit"
                            onClick={() =>
                            handleOpenInvoice(order)
                            }
                        >
                            Open Invoice
                        </div>
                        <div
                            className="hardCopyAddressEdit"
                            onClick={() => {
                            setSelectedCancelModal(order);
                            }}
                        >
                            Cancel Order
                        </div>
                        {(userData?.role === AccountType.OWNER || userData?.role === AccountType.ADMIN) && <div
                            className="hardCopyAddressEdit"
                            onClick={() => {
                            setSelectedDeleteModal(order);
                            }}
                        >
                            Delete Order
                        </div>}
                        </div>

                        
                    )}

                    {moreOptions === order.id &&
                    order.status !== "in-progress" &&
                    order.status !== "assigned" &&
                    order.status !== "cancelled" &&
                    order.status !== "completed" &&
                    order.status !== "created" &&
                    (
                        <div>
                        {order.paypalOrderID ===
                            "pay-later" && (
                            <div className="hardCopyAddressEditWrap">
                                <div
                                className="hardCopyAddressEdit"
                                onClick={() => {
                                    setSelectedCancelModal(order);
                                }}
                                >
                                Cancel Order
                                </div>{" "}
                                {(userData?.role === AccountType.OWNER || userData?.role === AccountType.ADMIN) && <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => {
                                    setSelectedDeleteModal(order);
                                    }}
                                >
                                    Delete Order
                                </div>}
                            </div>
                            )}
                        {order.paypalOrderID !==
                            "pay-later" && (
                            <div className="hardCopyAddressEditWrap">
                                <div
                                className="hardCopyAddressEdit"
                                onClick={() => {
                                    setSelectedCancelModal(order);
                                }}
                                >
                                Cancel Order
                                </div>
                                <div
                                className="hardCopyAddressEdit"
                                onClick={() =>
                                    handleOpenInvoice(order)
                                }
                                >
                                Open Invoice
                                </div>
                                {(userData?.role === AccountType.OWNER || userData?.role === AccountType.ADMIN) && <div
                                    className="hardCopyAddressEdit"
                                    onClick={() => {
                                    setSelectedDeleteModal(order);
                                    }}
                                >
                                    Delete Order
                                </div>}
                            </div>
                            )}
                        </div>
                    )}

                    {moreOptions === order.id &&
                    order.status === "cancelled" && (
                        <div className="hardCopyAddressEditWrap">
                        <div
                            className="hardCopyAddressEdit"
                            onClick={() => setReopenOrderPopup(order)}
                        >
                            Reopen Order
                        </div>
                        {(userData?.role === AccountType.OWNER || userData?.role === AccountType.ADMIN) && <div
                            className="hardCopyAddressEdit"
                            onClick={() => {
                            setSelectedDeleteModal(order);
                            }}
                        >
                            Delete Order
                        </div>}
                        </div>
                    )}

                    {moreOptions === order.id &&
                    order.status === "created" && (
                        <div className="hardCopyAddressEditWrap">
                        <div
                            className="hardCopyAddressEdit"
                            onClick={() => {
                            setSelectedCancelModal(order);
                            }}
                        >
                            Cancel Order
                        </div>
                        {(userData?.role === AccountType.OWNER || userData?.role === AccountType.ADMIN) && <div
                            className="hardCopyAddressEdit"
                            onClick={() => {
                            setSelectedDeleteModal(order);
                            }}
                        >
                            Delete Order
                        </div>}
                        </div>
                    )}

                    {moreOptions === order.id &&
                    order.status === "completed" && (
                        <div className="hardCopyAddressEditWrap">
                        <div
                            className="hardCopyAddressEdit"
                            onClick={() =>
                            handleOpenInvoice(order)
                            }
                        >
                            Open Invoice
                        </div>

                        {(userData?.role === AccountType.OWNER || userData?.role === AccountType.ADMIN) && <div
                            className="hardCopyAddressEdit"
                            onClick={() => {
                            setSelectedDeleteModal(order);
                            }}
                        >
                            Delete Order
                        </div>}

                        {/* <div
                            className="hardCopyAddressEdit accountDetailMoreBtnRow relative"
                            onClick={() => downloadPackage(order)}
                        >
                            <p>Download Package </p>
                            <INFO
                            onMouseOver={() => {
                                setShowDetailModal(
                                order.id + "download-package"
                                );
                            }}
                            onMouseLeave={() => {
                                setShowDetailModal("");
                            }}
                            />

                            {showDetailModal ===
                            order.id + "download-package" && (
                                <div
                                className="accountdetailHoverBox"
                                style={{
                                    top: "-100px",
                                    left: "-50px",
                                }}
                                >
                                <ul className="quotewidth accountDetailslist">
                                    <li>Source files</li>
                                    <li>Translated files</li>
                                    <li>Revised files</li>
                                    <li>Invoice files</li>
                                </ul>
                                </div>
                            )}
                        </div> */}
                        </div>
                    )}

                
                    
                </div>
                </td>
                </tr>
                )
        })}
      </tbody>
      )
    }

     const statusOverlayProps = useSpring({
      display: refreshing ? "flex" : "none",
  });

  // console.log(hits)

  const handleDeleteOrder = async (order) => {
    setDeleteBtnText("Deleting...");
    setMoreOptions("");

    await firestore.collection("orders").doc(order.id).delete().then(async() => {
      if(order.orderInvoiceId){
        await firestore.collection("orderInvoices").doc(order.orderInvoiceId).delete().then(() => {
          setTimeout(() => {
            setSelectedDeleteModal("");
            setDeleteBtnText("Delete Order");
            setMoreOptions("");
            refresh();
          }, 5000)
        }).catch((error) => {
          console.log(error);
          setDeleteBtnText("Delete Order");
        });
      }

    }).catch((error) => {
      console.log(error);
      setDeleteBtnText("Delete Order");
      setMoreOptions("");
    });
  }

    return (
    <>
      <Configure filters={filters} hitsPerPage={20}/>
      {refreshing &&  <animated.div
      style={statusOverlayProps}
      className="checkoutStatusOverlay"
    >
      Assigning Translator, Please wait<span className="dotsLoading">...</span>
    </animated.div>}

     <QueryFilters
        setFilterStartTimestamp={setFilterStartTimestamp}
        filterStartTimestamp={filterStartTimestamp}
        setFilterEndTimestamp={setFilterEndTimestamp}
        filterEndTimestamp={filterEndTimestamp}
        setDatePeriod={setDatePeriod}
        datePeriod={datePeriod}
        setStatusFilter={setStatusFilter}
        statusFilter={statusFilter}
        setServicesFilter={setServicesFilter}
        servicesFilter={servicesFilter}
        setSelectedClients={setSelectedClients}
        selectedClients={selectedClients}
        setSelectedMembers={setSelectedTranslators}
        selectedMembers={selectedTranslators}
        setSelectedLanguageFilter={setSelectedLanguageFilter}
        selectedLanguageFilter={selectedLanguageFilter}
        baseUrl="/office/translations"
      />

    {openInvoiceModal && <OpenInvoiceModal type="order" order={openInvoiceModal} onClose={() => setOpenInvoiceModal(null)}/>}

      {selectedCancelModal !== "" && (
        <PopUpModal
          title={"Cancel Order"}
          backBtnText="Back to Orders"
          subText="Are you sure you want to cancel this order?"
          text={(selectedCancelModal.orderNumber)}
          btnText={cancelBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setSelectedCancelModal("")}
          onClick={() => handleCancelOrder(selectedCancelModal.paypalOrderID !== "auto-billing" && selectedCancelModal.paypalOrderID !== "pay-later")}
          onBackClick={() => {
            setSelectedCancelModal("");
          }}
          disableBtn={cancelBtnText === "Cancelling..."}
          warningText={
            selectedCancelModal.paypalOrderID !== "auto-billing" && selectedCancelModal.paypalOrderID !== "pay-later"
              ? "The order has already been paid for by the client. After canceling, the order status will change to “on Hold” for refund to the client."
              : false
          }
        >
          <CANCELORDER />
        </PopUpModal>
      )}
      {selectedDeleteModal !== "" && (
        <PopUpModal
          title={"Delete Order"}
          backBtnText="Back to Orders"
          subText="Are you sure you want to delete this order?"
          text={(selectedDeleteModal.orderNumber)}
          btnText={deleteBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setSelectedDeleteModal("")}
          onClick={() => handleDeleteOrder(selectedDeleteModal)}
          onBackClick={() => {
            setSelectedDeleteModal("");
          }}
          disableBtn={deleteBtnText === "Deleting..."}
        >
          <CANCELORDER />
        </PopUpModal>
      )}
      {reOpenOrderPopup !== "" && (
        <ReopenOrderPopup
          onClick={ReopenOrder(reOpenOrderPopup)}
          onCancelClick={handleReopanOrederPopup}
        />
      )}
      {selectedSendPayment !== "" && (
        <SendPaymentLinkPopUp
          data={selectedSendPayment}
          type={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? "invoice" : "order"}
          id={selectedSendPayment.orderInvoiceId && selectedSendPayment.status !== "created" ? selectedSendPayment.orderInvoiceId : selectedSendPayment.id}
          onClose={() => setSelectedSendPayment("")}
        />
      )}
    
    <AccountNavBar
    showButton={true}
    windowSize={windowSize}
    selectedTab="orders"
    accountMainPadding={false}
    admin={true}
    >
    <div className="accountMainTitleRow px-5 pt-5">
        <h2 className="accountMainTitle">Orders</h2>
        
        <SearchBox classNames={{
        root: "newSearchbox",
        form: "newSearchbox_form",
        input: "newSearchbox_input",
        reset: "hidden",
        loadingIndicator: "hidden",
        }} 
        placeholder="Search By ID, Client or translator" 
        submitIconComponent={() => <SEARCHICON/>} />
    </div>

    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 lg:w-fit w-full px-4 gap-4">
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "date" ||
                    filterStartTimestamp ||
                    filterEndTimestamp
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "date" ? "" : "date"));
            }}
            >
            <DATE />
            <p className="accountDetailsFilterText">
                {getSelectedDateText()}
            </p>
            {showFilter === "date" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "date" && (
            <DateFilter
                setShowModal={setShowFilter}
                startTimestamp={filterStartTimestamp}
                setStartTimestamp={setFilterStartTimestamp}
                endTimestamp={filterEndTimestamp}
                setEndTimestamp={setFilterEndTimestamp}
                period={datePeriod}
                setPeriod={setDatePeriod}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "name" || selectedClients.length > 0
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "name" ? "" : "name"));
            }}
            >
            <CLIENT />
            <p className="accountDetailsFilterText">
                Client{" "}
                {selectedClients.length > 0
                ? ` (${selectedClients.length}) `
                : ""}
            </p>
            {showFilter === "name" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "name" && (
            <Clientsfilter
            setShowModal={setShowFilter}
            clients={clients}
            setSelectedClients={setSelectedClients}
            selectedClients={selectedClients}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "language" ||
                    (selectedLanguageFilter.languageFrom !== "" &&
                    selectedLanguageFilter.languageFrom !== "")
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "language" ? "" : "language"));
            }}
            >
            <LANGUAGES />
            <p className="accountDetailsFilterText">
                {getSelectedLanguage()}
            </p>
            {showFilter === "language" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "language" && (
            <LanguageFilter
                setShowModal={setShowFilter}
                setSelectedLanguageFilter={setSelectedLanguageFilter}
                selectedLanguageFilter={selectedLanguageFilter}
                isLast={true}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "services" || servicesFilter.length > 0
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "services" ? "" : "services"));
            }}
            >
            <SERVICES />
            <p className="accountDetailsFilterText">
                Services{" "}
                {servicesFilter.length > 0
                ? ` (${servicesFilter.length}) `
                : ""}
            </p>
            {showFilter === "services" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "services" && (
            <SearchFilter
                type="services"
                setStatusFilter={setServicesFilter}
                selectedFilters={servicesFilter}
                setShowModal={setShowFilter}
                isLast={true}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === AccountType.TRANSLATER ||
                    selectedTranslators.length > 0
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) =>
                f === AccountType.TRANSLATER ? "" : AccountType.TRANSLATER
                );
            }}
            >
            <TRANSLATOR />
            <p className="accountDetailsFilterText">
                Translator{" "}
                {selectedTranslators.length > 0
                ? ` (${selectedTranslators.length}) `
                : ""}
            </p>
            {showFilter === AccountType.TRANSLATER ? <UP /> : <DOWN />}
            </div>
            {showFilter === AccountType.TRANSLATER && (
            <Clientsfilter
                setShowModal={setShowFilter}
                clients={clients.filter(
                (el) => el.role === AccountType.TRANSLATER || el.role === AccountType.SUPPORT || el.role === AccountType.SUPPORTPLUS
                )}
                setSelectedClients={setSelectedTranslators}
                selectedClients={selectedTranslators}
                isClientFilter={true}
                hideCount={true}
            />
            )}
        </div>
        <div className="relative">
            <div
            className="accountDetailsFilter"
            style={{
                borderColor:
                showFilter === "status" || statusFilter !== ""
                    ? "#12ABBF"
                    : "#E6E7E9",
            }}
            onClick={(e) => {
                setShowFilter((f) => (f === "status" ? "" : "status"));
            }}
            >
            <STATUS />
            <p className="accountDetailsFilterText">
                Status
            </p>
            {showFilter === "status" ? <UP /> : <DOWN />}
            </div>
            {showFilter === "status" && (
            <SearchFilter
                type="status"
                accountType="admin"
                setStatusFilter={setStatusFilter}
                selectedFilters={statusFilter}
                setShowModal={setShowFilter}
                isLast={true}
            />
            )}
        </div>
    </div>

    <div className="accountDetailsScroll w-full">
        {loading ? <NoData loadingText={"orders"} loading={true} showBtn={false} type="orders"/> :
        (!checkFetchAlgoliaData() ? localOrders.length === 0 : hits.length === 0)  &&
        <NoData
        type="order"
        text={checkAnyFilterSelected() || query !== "" ? "Please select another filter" : ""}
        title={checkAnyFilterSelected() || query !== "" ? "No Order Matching This Filter": "You Don't Have Any Active Order Yet"}
        showBtn={false}
        /> }
        {(!checkFetchAlgoliaData() ? localOrders.length > 0 : hits.length > 0) && !loading &&
        <table className="accountDetailsTable" style={{display: loading ? "none" : "table"}}>
            <thead>
                <tr>
                    <th  >
                    <div className="accountData">
                        <p className="accountDetailsHeading">ID</p>
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Date</p>
                        { currentRefinement === "order_time_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_time_asc")}/> 
                        : currentRefinement === "order_time_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_time_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_time_dsc")}/>
                        }
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Client Name</p>
                        { currentRefinement === "order_requestBy_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_requestBy_asc")}/> 
                        : currentRefinement === "order_requestBy_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_requestBy_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_requestBy_asc")}/>
                        }
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Сlient email</p>
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Languages</p>
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Services</p>
                    </div>
                    </th>

                    <th>
                    <div className="accountData">
                        {showDetailModal === "add-comment" && (
                        <div className="accountdetailHoverBox addCommentHover">
                            <p className="accountDetailsText">Chat</p>
                        </div>
                        )}
                        <MESSAGE
                        style={{ cursor: "pointer" }}
                        onMouseOver={() => setShowDetailModal("add-comment")}
                        onMouseLeave={() => setShowDetailModal("")}
                        />
                    </div>
                    </th>

                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Translator</p>
                        { currentRefinement === "order_translator_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_translator_asc")}/> 
                        : currentRefinement === "order_translator_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_translator_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_translator_asc")}/>
                        }
                    </div>
                    </th>

                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Status</p>
                        { currentRefinement === "order_status_dsc" ? 
                        <SORT_DSC className="sortIcon" onClick={() => refine("order_status_asc")}/> 
                        : currentRefinement === "order_status_asc" ?
                        <SORT_ASC className="sortIcon" onClick={() => refine("order_status_dsc")}/> 
                        : <SORTBLACK className="sortIcon" onClick={() => refine("order_status_asc")}/>
                        }
                    </div>
                    </th>
                    <th>
                    <div className="accountData">
                        <p className="accountDetailsHeading">Total</p>
                    </div>
                    </th>
                    <th>
                    <div
                        className="accountData">
                        <PAYMENT style={{ cursor: "pointer" }} />
                    </div>
                    </th>
                    <th></th>
                </tr>
                </thead>

            <TableDataComponent hits={!checkFetchAlgoliaData() ? localOrders : hits}/>

        </table>}
        {hits.length > 0 && 
        <Pagination
        padding={0}
        showFirst={false}
        showPrevious={true}
        showNext={true}
        showLast={false}
        classNames={{
            root: "w-full my-4 mx-2",
            list: "w-full flex justify-center items-center gap-2",
            item: "",
            selectedItem:"",
            disabledItem:"opacity-50 cursor-not-allowed",
            previousPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            nextPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            firstPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
            lastPageItem: "px-4 py-1 font-medium bg-primary text-white rounded-md hover:bg-primary/70 transition",
        }}
        translations={{
        previousPageItemText: 'Previous',
        nextPageItemText: 'Next',
        pageItemText: ({ currentPage, nbPages }) => `Page ${currentPage}`,
        previousPageItemAriaLabel: 'Go to previous page',
        nextPageItemAriaLabel: 'Go to next page',
        pageItemAriaLabel: ({ currentPage, nbPages }) => `Go to page ${currentPage} of ${nbPages}`,
        }}
        />}
    </div>
    
    </AccountNavBar>
    </>
  );
};

export default OrdersBackendComponent;
